module.exports = __webpack_public_path__ + "fonts/Montserrat-VariableFont_wght.ttf?52a37115b1d8d5d6ae0b0e373e692c9d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat-VariableFont_wght.ttf
// module id = 318
// module chunks = 0